import axios from 'axios';

const inst= axios.create({
    baseURL:'https://burger-builder-e562b.firebaseio.com/'
})

export default inst;

